import {
  CLEAR_RIDE_DETAILS,
  REQUEST_RIDE_DETAILS,
  RECEIVE_RIDE_DETAILS,
  SET_RIDE_DETAILS_TIMEOUT,
  UNSET_RIDE_DETAILS_TIMEOUT,
} from 'ondemand/actions/rideDetails';

export default function rideDetails(
  state = {
    agencyId: null,
    isFetching: false,
    item: null,
    timeout: null,
    rideId: null,
  },
  action,
) {
  switch (action.type) {
    case CLEAR_RIDE_DETAILS:
      return Object.assign({}, state, {item: null});
    case REQUEST_RIDE_DETAILS:
      return Object.assign({}, state, {isFetching: true});
    case RECEIVE_RIDE_DETAILS:
      return Object.assign({}, state, {
        agencyId: action.agencyId,
        isFetching: false,
        item: action.rideDetails,
        rideId: action.rideId,
      });
    case SET_RIDE_DETAILS_TIMEOUT:
      return Object.assign({}, state, {timeout: action.timeout});
    case UNSET_RIDE_DETAILS_TIMEOUT:
      return Object.assign({}, state, {timeout: null});
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/ondemand/reducers/rideDetails.js